var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "modal-dialog" }, [
    _c("div", { staticClass: "modal-content" }, [
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "modal-footer" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-default pull-left",
            attrs: { type: "button", "data-dismiss": "modal" },
          },
          [_vm._v("\n        キャンセル\n      ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.remove(_vm.freetext_index, _vm.modal_id)
              },
            },
          },
          [_vm._v("\n        実行する\n      ")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close",
          },
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      ),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-trash modal-icon" }),
      _vm._v(" "),
      _c("h4", { staticClass: "modal-title" }, [_vm._v("削除の確認")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-body" }, [
      _c("p", [
        _vm._v("\n        該当の項目を削除してもよろしいですか？\n      "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }